<template>
  <div class="section">
    <div class="container auth-container">
      <h2 class="title is-4 has-text-weight-semibold mb-1">{{ $t('auth.resetPassword')}}</h2>
      <p>{{$t('auth.resetPasswordExplanation')}}</p>

      <article v-if="isErr" class="message is-danger mt-1">
        <div class="message-body">{{ errMsg }}</div>
      </article>

      <form v-if="!emailSent" class="auth-form mt-1" @submit.prevent="resetPw">
        <!-- email -->
        <div class="field">
          <label class="label">{{$t('auth.email')}}</label>
          <div class="control has-icons-right">
            <input
              v-model="email"
              class="input is-medium"
              :class="{ 'is-danger': isErr }"
              type="email"
              :placeholder="$t('auth.enterYourEmail')"
              autocomplete="on"
              required
              @input="resetErrs"
              @focus="hideBottomNavbar(true)"
              @blur="hideBottomNavbar(false)"
            />
            <span class="icon is-small is-right">
              <i class="fas fa-envelope" />
            </span>
          </div>
        </div>
        <!-- ./email -->

        <div class="field mt-1">
          <div class="control">
            <button
              class="button is-primary is-default-size is-fullwidth"
              :class="{ 'is-loading': isLoading }"
            >{{$t('auth.sendResetLink')}}</button>
          </div>
        </div>
        <router-link class="mt-2 is-block has-text-centered" :to="{name:'signin'}">{{$t('auth.logIn')}}</router-link>
      </form>

      <div v-else class="mt-2">
        <article class="message is-success">
          <div
            class="message-body"
          >{{$t('auth.sendResetLinkSuccess')}}</div>
        </article>
 
        <router-link class="mt-2 is-block has-text-centered" :to="{name:'home'}">{{$t('ui.backToHomePage')}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
// import { auth } from '~/services/fireinit'

export default {
  data() {
    return {
      email: "",
      isErr: false,
      errMsg: "",
      isLoading: false,
      emailSent: false
    };
  },
  methods: {
    ...mapMutations({
      hideBottomNavbar: "ui/SET_HIDE_BOTTOM_NAVBAR"
    }),
    resetErrs() {
      this.isErr = false;
      this.errMsg = "";
    },
    async resetPw() {
      this.isLoading = true;
      this.isErr = "";
      this.errMsg = "";
      try {
        // await auth.sendPasswordResetEmail(this.email);
        await this.$store.dispatch("auth/resetPw", this.email);
        this.emailSent = true;
      } catch (error) {
        console.log(error);
        if (error.code === "auth/user-not-found") {
          this.isErr = true;
          this.errMsg =
            "Bu e-postaya ait bir kullanıcı bulunmamaktadır. Lütfen, e-posta adresinizi kontrol edip tekrar deneyin.";
        } else {
          this.isErr = true;
          this.errMsg =
            "İşleminiz gerçekleştirilemedi. Lütfen tekrar giriş yapmayı deneyin.";
        }
      }
      this.isLoading = false;
    }
  }
};
</script>
